function convertInchesToCM(num) {
  let eq =
    "Converting " +
    num +
    " inches to centimeters: \n" +
    num +
    " / 0.39370 = ";
  let rep = num  / 0.39370;
  return eq + rep.toFixed(3);
}

function convertInchesToFeet(num) {
  let eq =
    "Converting " +
    num +
    " inches to feet: \n" +
    num +
    " * 0.083333 = ";
  let rep = num * 0.083333;
  return eq + rep.toFixed(4);
}

function convertInchesToYards(num) {
  let eq =
    "Converting " +
    num +
    " inches to yards: \n" +
    num +
    " * 0.027778 = ";
  let rep = num * 0.027778;
  return eq + rep.toFixed(4);
}

function convertInchesToMiles(num) {
  let eq =
    "Converting " +
    num +
    " inches to miles: \n" +
    num +
    " * 0.000015783 = ";
  let rep = num * 0.000015783;
  return eq + rep.toFixed(6);
}

function convertInchesToMeters(num) {
  let eq =
    "Converting " +
    num +
    " inches to meters: \n" +
    num +
    " / 39.370 = ";
  let rep = num / 39.370;
  return eq + rep.toFixed(3);
}

function convertInchesToKilometers(num) {
  let eq =
    "Converting " +
    num +
    " inches to kilometers: \n" +
    num +
    " / 39370 = ";
  let rep = num / 39370;
  return eq + rep.toFixed(6);
}

export {
  convertInchesToCM,
  convertInchesToFeet,
  convertInchesToYards,
  convertInchesToMiles,
  convertInchesToMeters,
  convertInchesToKilometers
};
